import { useParams } from "react-router-dom";
import { Card, CardBody, CardHeader } from "../../../components/card/card";
import { useEffect, useState } from "react";
import { detailTrainingDeleteFile, detailTrainingDownloadFile, detailTrainingFileList, detailTrainingUploadFile } from "../../../config/apiSPA";
import EmptyStateTabelFile from "../../../components/emptyState/emptyStateTableFile";
import DateFormat from "../../../components/dateFormater/dateFormat1";
import ModalConfirm from "../../../components/modal/modalConfirm";
import ModalUploadFile2 from "../../../components/modal/modalUploadFile2";
import ModalInfo from "../../../components/modal/modalInfo";
import ModalLoading from "../../../components/modal/modalLoading";

const modalConfirmInitialState = {
  show: false,
  title: "",
  text: "",
  actionType: "",
  theme: "",
  id: null,
};
const modalUploadFileInitialState = {
  show: false,
  multiple: false,
};
const modalInfoInitialState = {
  show: false,
  title: "",
  text: "",
  theme: "",
};
const modalLoadingInitialState = {
  show: false,
  title: "",
  text: "",
  value: 0,
};
function TrainingReportFile() {
  const { id } = useParams();
  const [fileState, setFileState] = useState([]);
  const [modalConfirmState, setModalConfirmState] = useState(modalConfirmInitialState);
  const [modalUploadFileState, setModalUploadFileState] = useState(modalUploadFileInitialState);
  const [modalInfoState, setModalInfoState] = useState(modalInfoInitialState);
  const [modalLoadingState, setModalLoadingState] = useState(modalLoadingInitialState);
  const loadData = async () => {
    try {
      const res = await detailTrainingFileList(id);
      setFileState(res.data);
    } catch (error) {}
  };
  const handleClickDeleteFileList = (data) => {
    setModalConfirmState({
      show: true,
      title: "Warning !!",
      text: `Are you sure want to delete this file ? file: ${data.fileName}`,
      actionType: "deleteFileList",
      theme: "danger",
      id: data.id,
    });
  };
  const handleClickDeleteComfirm = async (deleteId, actionType) => {
    setModalConfirmState(modalConfirmInitialState);
    try {
      if (actionType === "deleteFileList") {
        const res = await detailTrainingDeleteFile(deleteId);
        setFileState(res.data);
      }
    } catch (error) {}
  };
  const handleUploadFile = () => {
    setModalUploadFileState({
      show: true,
      multiple: true,
    });
  };
  const handleSubmitUploadFile = async (formData) => {
    setModalUploadFileState(modalUploadFileInitialState);
    try {
      formData.append("trainingId", id);
      setModalLoadingState({
        show: true,
        title: "Loading...",
        text: "Please wait ....",
        value: 0,
      });
      const res = await detailTrainingUploadFile(formData, (i) => setModalLoadingState((a) => ({ ...a, value: i })));
      setFileState(res.data);
    } catch (error) {
      setModalInfoState({
        show: true,
        title: "Failed !!",
        text: `Failed uploading file. message: ${error.message}`,
        theme: "danger",
      });
    } finally {
      setModalLoadingState(modalLoadingInitialState);
    }
  };
  const handleDownLoadFileList = (list) => {
    detailTrainingDownloadFile(list.id);
  };

  useEffect(() => {
    loadData();
  }, []);
  return (
    <>
      <Card className="mb-4">
        <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">Training File/Document</CardHeader>
        <CardBody className="card-body pb-2">
          <div className="mb-2">
            <div className="d-block d-lg-flex align-items-center">
              <span onClick={handleUploadFile} className="btn btn-outline-theme me-2 mb-1">
                <i className="fa fa-fw fa-plus"></i>
                <span>Add files...</span>
              </span>
            </div>
          </div>
        </CardBody>
        <table className="table table-card mb-0 fs-13px">
          <thead>
            <tr className="fs-12px">
              <th className="pt-2 pb-2 w-25">FILENAME</th>
              <th className="pt-2 pb-2 w-25">SIZE</th>
              <th className="pt-2 pb-2 w-25">UPLOADED</th>
              <th className="pt-2 pb-2 w-25">ACTION</th>
            </tr>
          </thead>
          <tbody className="files">
            {fileState.length > 0 ? (
              fileState.map((list, index) => (
                <tr key={index}>
                  <td className="align-middle">{list.fileName}</td>
                  <td className="align-middle">{list.size}</td>
                  <td className="align-middle">{DateFormat(list.created_at)}</td>
                  <td>
                    <div className="d-flex gap-2">
                      <a href="#/" onClick={() => handleClickDeleteFileList(list)} className="btn btn-outline-default btn-sm">
                        <i className="fas fa-trash-alt text-danger"></i>
                      </a>
                      <a href="#/" onClick={() => handleDownLoadFileList(list)} className="btn btn-outline-default btn-sm">
                        <i className="fas fa-download text-theme"></i>
                      </a>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <EmptyStateTabelFile colSpan={4} />
            )}
          </tbody>
        </table>
      </Card>
      <ModalLoading show={modalLoadingState.show} onHide={() => setModalLoadingState(modalLoadingInitialState)} title={modalLoadingState.title} text={modalLoadingState.text} value={modalLoadingState.value} />
      <ModalUploadFile2 show={modalUploadFileState.show} onHide={() => setModalUploadFileState(modalUploadFileInitialState)} multiple={modalUploadFileState.multiple} submitClick={handleSubmitUploadFile} />
      <ModalInfo show={modalInfoState.show} onHide={() => setModalInfoState(modalInfoInitialState)} title={modalInfoState.title} text={modalInfoState.text} clicked={() => setModalInfoState(modalInfoInitialState)} />
      <ModalConfirm
        show={modalConfirmState.show}
        onHide={() => setModalConfirmState(modalConfirmInitialState)}
        title={modalConfirmState.title}
        text={modalConfirmState.text}
        theme={modalConfirmState.theme}
        id={modalConfirmState.id}
        clicked={(id) => handleClickDeleteComfirm(id, modalConfirmState.actionType)}
      />
    </>
  );
}

export default TrainingReportFile;
